'use strict';

import UserListButtons from './components/UserListButtons.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('user-list-buttons', UserListButtons);

    }
}